import React, { Component } from "react";
import { connect } from "react-redux";
import List from "@material-ui/core/List";
import { edit_quantity } from "../../store/actions";
import { registerGlanceView } from "../../store/actions/analytics";

import { ReactComponent as Empty } from "../PastOrders/assets/empty.svg";
import CartItem from "./CartItem";
import ActionButton from "../ActionButton";
import ProductHeader from "../ProductDetails/ProductHeader";

//analytics
import ReactPixel from "@bettercart/react-facebook-pixel";
import ReactGA from "react-ga4";
import SnapchatPixel from "react-snapchat-pixel";
import { GTM } from "../../App";
import TiktokPixel from "../../tiktok-pixel";
import TwitterPixel from "../../TwitterPixel";
import Gift from "../CheckoutProcess/Confirmation/Gift";
import AppliedCoupons from "../CheckoutProcess/Confirmation/AppliedCoupons";
import SpecialRemarks from "../CheckoutProcess/Confirmation/SpecialRemarks";
import SpecialRemarksFile from "../CheckoutProcess/Confirmation/SpecialRemarksFile";
import { Button } from "@material-ui/core";
import NavigateBeforeOutlinedIcon from "@material-ui/icons/NavigateBeforeOutlined";
import ProductRecommendations from "../ProductDetails/ProductRecommendations";
import ShareCartDrawer from "../CheckoutProcess/Confirmation/ShareCartDrawer";
import {
  FacebookInitiateCheckout,
  generateUniqueID,
  SnapchatCheckout,
  TikTokInitiateCheckout,
} from "../../Helpers/analytics";
import AdditionalInformation from "../AreaSelect/Pickup/AdditionalInformation";
import { getProduct } from "../../store/reducers/store";
import NutritionalFacts from "../ActionButton/NutritionalFacts";

import {
  getDiscountedPrice,
  getProductDiscountAmount,
} from "../../Helpers/promotions";
import { shouldShowNumberError } from "../../Helpers/gift";

export class index extends Component {
  state = {
    recommendationVisibilityRegistered: false,
    shareCartDrawerOpen: false,
    errorName:
      this.props.settings.enable_force_gift_name_number &&
      !this.props.promise.gift_name,
    errorNumber: shouldShowNumberError(this.props),
    nutritionalFacts: {},
  };

  refreshTabbyWidget = () => {
    try {
      const element = document.querySelector("#TabbyPromo");
      if (element) {
        const parent = element.parentNode;
        const nextSibling = element.nextSibling;
        element.remove();

        const newElement = document.createElement("div");
        newElement.id = "TabbyPromo";

        if (nextSibling) {
          parent.insertBefore(newElement, nextSibling);
        } else {
          parent.appendChild(newElement);
        }
      }
    } catch (e) {}
  };

  componentDidMount() {
    document.addEventListener("scroll", this.recommendationIsInViewport);
    window.scrollTo(0, 0);
    this.calculateNutritions();
    const { settings } = this.props;
    if (settings.enable_tabby_widgets) {
      console.log({
        selector: "#TabbyPromo", // required, content of tabby Promo Snippet will be placed in element with that selector.
        currency: this.props.settings.currency_iso, // required, currency of your product. AED|SAR|KWD|BHD|QAR only supported, with no spaces or lowercase.
        price: String(this.props.cart.price), // required, price or the product. 2 decimals max for AED|SAR|QAR and 3 decimals max for KWD|BHD.
        installmentsCount: 4, // Optional, for non-standard plans.
        lang: this.props.language === "arabic" ? "ar" : "en", // Optional, language of snippet and popups, if the property is not set, then it is based on the attribute 'lang' of your html tag.
        source: "product", // Optional, snippet placement; `product` for product page and `cart` for cart page.
        publicKey: this.props.settings.tabby_public_key, // required, store Public Key which identifies your account when communicating with tabby.
        merchantCode: this.props.settings.tabby_merchant_code, // required
      });
      new window.TabbyPromo({
        selector: "#TabbyPromo", // required, content of tabby Promo Snippet will be placed in element with that selector.
        currency: this.props.settings.currency_iso, // required, currency of your product. AED|SAR|KWD|BHD|QAR only supported, with no spaces or lowercase.
        price: String(this.props.cart.price), // required, price or the product. 2 decimals max for AED|SAR|QAR and 3 decimals max for KWD|BHD.
        installmentsCount: 4, // Optional, for non-standard plans.
        lang: this.props.language === "arabic" ? "ar" : "en", // Optional, language of snippet and popups, if the property is not set, then it is based on the attribute 'lang' of your html tag.
        source: "product", // Optional, snippet placement; `product` for product page and `cart` for cart page.
        publicKey: this.props.settings.tabby_public_key, // required, store Public Key which identifies your account when communicating with tabby.
        merchantCode: this.props.settings.tabby_merchant_code, // required
      });
    }
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.settings.enable_tamara_widgets) {
      try {
        if (prevProps.language !== this.props.language) {
          window.tamaraWidgetConfig.lang =
            this.props.language === "arabic" ? "ar" : "en";
        }
        window.TamaraWidgetV2.refresh();
      } catch (e) {
        console.error(e);
      }
    }
    if (this.props.settings.enable_tabby_widgets) {
      try {
        if (
          prevProps.language !== this.props.language ||
          this.props.cart.price !== prevProps.cart.price
        ) {
          this.refreshTabbyWidget();
          new window.TabbyPromo({
            selector: "#TabbyPromo", // required, content of tabby Promo Snippet will be placed in element with that selector.
            currency: this.props.settings.currency_iso, // required, currency of your product. AED|SAR|KWD|BHD|QAR only supported, with no spaces or lowercase.
            price: String(this.props.cart.price), // required, price or the product. 2 decimals max for AED|SAR|QAR and 3 decimals max for KWD|BHD.
            installmentsCount: 4, // Optional, for non-standard plans.
            lang: this.props.language === "arabic" ? "ar" : "en", // Optional, language of snippet and popups, if the property is not set, then it is based on the attribute 'lang' of your html tag.
            source: "product", // Optional, snippet placement; `product` for product page and `cart` for cart page.
            publicKey: this.props.settings.tabby_public_key, // required, store Public Key which identifies your account when communicating with tabby.
            merchantCode: this.props.settings.tabby_merchant_code, // required
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
  };

  calculateNutritions = () => {
    const { cart_items, store, promo_items, settings } = this.props;
    if (!settings.show_nutrition_facts) return;

    let res = {};
    let totalCalories = 0;
    let totalProtein = 0;
    let totalCarbs = 0;
    let totalFats = 0;
    let isDairyFree = true;
    let isSugarFree = true;
    let isGlutenFree = true;
    let isNutFree = true;
    let isOrganic = true;
    let isVegan = true;
    let isVegetarian = true;
    let containsGluten = true;
    let containsNutsSesame = true;
    let containsDairy = true;
    let containsEgg = true;
    let containsSeafoodShellfish = true;
    let containsChilli = true;

    cart_items.concat(promo_items).forEach((item) => {
      let current_product = getProduct(
        store.categories,
        item.id,
        item.category_id,
        item.parent
      );
      if (current_product) {
        totalCalories += item.quantity * current_product.calories;
        totalProtein += item.quantity * current_product.protein;
        totalCarbs += item.quantity * current_product.carbs;
        totalFats += item.quantity * current_product.fats;

        if (!current_product.dietary_restrictions?.includes("Dairy free"))
          isDairyFree = false;
        if (!current_product.dietary_restrictions?.includes("Gluten free"))
          isGlutenFree = false;
        if (!current_product.dietary_restrictions?.includes("Sugar free"))
          isSugarFree = false;
        if (!current_product.dietary_restrictions?.includes("Nut free"))
          isNutFree = false;
        if (!current_product.dietary_restrictions?.includes("Vegan"))
          isVegan = false;
        if (!current_product.dietary_restrictions?.includes("Vegetarian"))
          isVegetarian = false;
        if (!current_product.dietary_restrictions?.includes("Organic"))
          isOrganic = false;
        if (!current_product.dietary_restrictions?.includes("Gluten"))
          containsGluten = false;
        if (!current_product.dietary_restrictions?.includes("Nuts/Sesame"))
          containsNutsSesame = false;
        if (!current_product.dietary_restrictions?.includes("Dairy"))
          containsDairy = false;
        if (!current_product.dietary_restrictions?.includes("Egg"))
          containsEgg = false;
        if (
          !current_product.dietary_restrictions?.includes("Seafood/Shellfish")
        )
          containsSeafoodShellfish = false;
        if (!current_product.dietary_restrictions?.includes("Chilli"))
          containsChilli = false;

        let options = item.options;
        let currentProductOptions = current_product.options;
        let selected_option = {};

        if (options) {
          for (let [key, value] of Object.entries(options)) {
            let existOption = currentProductOptions.find(
              (element) => element.id == key
            );
            selected_option = value.selectedOptions;
            if (existOption) {
              for (let [selected_key, selected_value] of Object.entries(
                selected_option
              )) {
                let existChoice = existOption.choices.find(
                  (element) => element.id == selected_key
                );

                totalCalories +=
                  selected_value.quantity *
                  existChoice.calories *
                  ((existOption.quantity_exclusive && 1) || item.quantity);
                totalProtein +=
                  selected_value.quantity *
                  existChoice.protein *
                  ((existOption.quantity_exclusive && 1) || item.quantity);
                totalCarbs +=
                  selected_value.quantity *
                  existChoice.carbs *
                  ((existOption.quantity_exclusive && 1) || item.quantity);
                totalFats +=
                  selected_value.quantity *
                  existChoice.fats *
                  ((existOption.quantity_exclusive && 1) || item.quantity);

                if (existChoice.dietary_restrictions) {
                  if (!existChoice.dietary_restrictions?.includes("Dairy free"))
                    isDairyFree = false;
                  if (
                    !existChoice.dietary_restrictions?.includes("Gluten free")
                  )
                    isGlutenFree = false;
                  if (!existChoice.dietary_restrictions?.includes("Sugar free"))
                    isSugarFree = false;
                  if (!existChoice.dietary_restrictions?.includes("Nut free"))
                    isNutFree = false;
                  if (!existChoice.dietary_restrictions?.includes("Vegan"))
                    isVegan = false;
                  if (!existChoice.dietary_restrictions?.includes("Vegetarian"))
                    isVegetarian = false;
                  if (!existChoice.dietary_restrictions?.includes("Organic"))
                    isOrganic = false;
                  if (!existChoice.dietary_restrictions?.includes("Gluten"))
                    containsGluten = false;
                  if (
                    !existChoice.dietary_restrictions?.includes("Nuts/Sesame")
                  )
                    containsNutsSesame = false;
                  if (!existChoice.dietary_restrictions?.includes("Dairy"))
                    containsDairy = false;
                  if (!existChoice.dietary_restrictions?.includes("Egg"))
                    containsEgg = false;
                  if (
                    !existChoice.dietary_restrictions?.includes(
                      "Seafood/Shellfish"
                    )
                  )
                    containsSeafoodShellfish = false;
                  if (!existChoice.dietary_restrictions?.includes("Chilli"))
                    containsChilli = false;
                }
              }
            }
          }
        }
      }
    });

    res = {
      totalCalories: totalCalories,
      totalProtein: totalProtein,
      totalCarbs: totalCarbs,
      totalFats: totalFats,
      isDairyFree: isDairyFree,
      isSugarFree: isSugarFree,
      isGlutenFree: isGlutenFree,
      isNutFree: isNutFree,
      isOrganic: isOrganic,
      isVegan: isVegan,
      isVegetarian: isVegetarian,
      containsGluten: containsGluten,
      containsNutsSesame: containsNutsSesame,
      containsDairy: containsDairy,
      containsEgg: containsEgg,
      containsSeafoodShellfish: containsSeafoodShellfish,
      containsChilli: containsChilli,
    };
    this.setState({ nutritionalFacts: res });
  };

  checkDietryRestriction = (item) => {
    const { cart_items, store, promo_items, settings } = this.props;
    let res = {};
    let isDairyFree = true;
    let isSugarFree = true;
    let isGlutenFree = true;
    let isNutFree = true;
    let isOrganic = true;
    let isVegan = true;
    let isVegetarian = true;
    let containsGluten = true;
    let containsNutsSesame = true;
    let containsDairy = true;
    let containsEgg = true;
    let containsSeafoodShellfish = true;
    let containsChilli = true;

    let current_product = getProduct(
      store.categories,
      item.id,
      item.category_id,
      item.parent
    );
    if (current_product) {
      if (!current_product.dietary_restrictions?.includes("Dairy free"))
        isDairyFree = false;
      if (!current_product.dietary_restrictions?.includes("Gluten free"))
        isGlutenFree = false;
      if (!current_product.dietary_restrictions?.includes("Sugar free"))
        isSugarFree = false;
      if (!current_product.dietary_restrictions?.includes("Nut free"))
        isNutFree = false;
      if (!current_product.dietary_restrictions?.includes("Vegan"))
        isVegan = false;
      if (!current_product.dietary_restrictions?.includes("Vegetarian"))
        isVegetarian = false;
      if (!current_product.dietary_restrictions?.includes("Organic"))
        isOrganic = false;
      if (!current_product.dietary_restrictions?.includes("Gluten"))
        containsGluten = false;
      if (!current_product.dietary_restrictions?.includes("Nuts/Sesame"))
        containsNutsSesame = false;
      if (!current_product.dietary_restrictions?.includes("Dairy"))
        containsDairy = false;
      if (!current_product.dietary_restrictions?.includes("Egg"))
        containsEgg = false;
      if (!current_product.dietary_restrictions?.includes("Seafood/Shellfish"))
        containsSeafoodShellfish = false;
      if (!current_product.dietary_restrictions?.includes("Chilli"))
        containsChilli = false;

      let options = item.options;
      let currentProductOptions = current_product.options;
      let selected_option = {};

      if (options) {
        for (let [key, value] of Object.entries(options)) {
          let existOption = currentProductOptions.find(
            (element) => element.id == key
          );
          selected_option = value.selectedOptions;
          if (existOption) {
            for (let [selected_key, selected_value] of Object.entries(
              selected_option
            )) {
              let existChoice = existOption.choices.find(
                (element) => element.id == selected_key
              );
              if (existChoice.dietary_restrictions) {
                if (!existChoice.dietary_restrictions?.includes("Dairy free"))
                  isDairyFree = false;
                if (!existChoice.dietary_restrictions?.includes("Gluten free"))
                  isGlutenFree = false;
                if (!existChoice.dietary_restrictions?.includes("Sugar free"))
                  isSugarFree = false;
                if (!existChoice.dietary_restrictions?.includes("Nut free"))
                  isNutFree = false;
                if (!existChoice.dietary_restrictions?.includes("Vegan"))
                  isVegan = false;
                if (!existChoice.dietary_restrictions?.includes("Vegetarian"))
                  isVegetarian = false;
                if (!existChoice.dietary_restrictions?.includes("Organic"))
                  isOrganic = false;
                if (!existChoice.dietary_restrictions?.includes("Gluten"))
                  containsGluten = false;
                if (!existChoice.dietary_restrictions?.includes("Nuts/Sesame"))
                  containsNutsSesame = false;
                if (!existChoice.dietary_restrictions?.includes("Dairy"))
                  containsDairy = false;
                if (!existChoice.dietary_restrictions?.includes("Egg"))
                  containsEgg = false;
                if (
                  !existChoice.dietary_restrictions?.includes(
                    "Seafood/Shellfish"
                  )
                )
                  containsSeafoodShellfish = false;
                if (!existChoice.dietary_restrictions?.includes("Chilli"))
                  containsChilli = false;
              }
            }
          }
        }
      }
    }

    res = {
      isDiaryFree: isDairyFree,
      isSugarFree: isSugarFree,
      isGlutenFree: isGlutenFree,
      isNutFree: isNutFree,
      isOrganic: isOrganic,
      isVegan: isVegan,
      isVegetarian: isVegetarian,
      containsGluten: containsGluten,
      containsNutsSesame: containsNutsSesame,
      containsDairy: containsDairy,
      containsEgg: containsEgg,
      containsSeafoodShellfish: containsSeafoodShellfish,
      containsChilli: containsChilli,
    };
    return res;
  };

  recommendationsRef = React.createRef();

  handleDialogContinue = () => {
    // if (
    //   this.props.settings.enable_gift_form_open &&
    //   this.props.settings.enable_gifts &&
    //   this.props.settings.enable_gifts_staff &&
    //   this.props.promise?.isGift
    // ) {
    //   if (
    //     this.props.settings.enable_force_gift_name_number &&
    //     (!this.props.promise.gift_name ||
    //       !this.props.promise.gift_recipient_number)
    //   ) {
    //     if (
    //       this.props.promise.gift_name === "" ||
    //       !this.props.promise.gift_name
    //     ) {
    //       this.setState({ errorName: true });
    //     }
    //     if (
    //       this.props.promise.gift_recipient_number === "" ||
    //       !this.props.promise.gift_recipient_number
    //     ) {
    //       this.setState({ errorNumber: true });
    //     }
    //     window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    //     return;
    //   }
    // }

    this.props.history.push("/checkout/confirmation");

    if (this.props.settings.enable_fb_pixel && this.props.settings.fb_pixel) {
      const eventId = generateUniqueID(10);
      ReactPixel.track(
        "InitiateCheckout",
        { event_id: eventId },
        { eventID: eventId }
      );
      if (this.props.settings.enable_conversion_api) {
        FacebookInitiateCheckout(eventId);
      }
    }
    if (
      this.props.settings.enable_snap_pixel &&
      this.props.settings.snap_pixel
    ) {
      SnapchatCheckout(this.props);
    }
    if (
      this.props.settings.enable_google_analytics &&
      this.props.settings.google_analytics
    ) {
      ReactGA.event({
        category: "orders",
        action: "customer reviews purchase",
        label: "begin_checkout",
      });
    }
    if (GTM) {
      GTM.track("begin_checkout", {
        ecommerce: {
          currency: this.props.settings.currency_iso,
          value: this.props.cart.price,
          items: this.props.cart.cart.map((item) => {
            return {
              item_id: item.id,
              item_name: item.name,
              currency: this.props.settings.currency_iso,
              price: item.total_price + item.quantityExcludedOptionsTotal,
              quantity: item.quantity,
            };
          }),
        },
      });
    }
    if (
      this.props.settings.enable_tiktok_pixel &&
      this.props.settings.tiktok_pixel
    ) {
      TikTokInitiateCheckout(this.props);
    }
    if (TwitterPixel.isInitialized()) {
      if (this.props.settings.twitter_events["Checkout Initiated"]) {
        TwitterPixel.track(
          this.props.settings.twitter_events["Checkout Initiated"]
        );
      }
    }
  };

  shouldShowCheckoutButton = () => {
    const { settings, cart } = this.props;
    if (settings.is_branch_based_ordering && !this.props.branch) return false;
    if (
      !settings.is_branch_based_ordering &&
      !this.props.address?.area &&
      !this.props.address?.pickupArea &&
      cart.delivered_items > 0 &&
      cart.charged_items > 0
    )
      return false;
    if (
      settings.is_branch_based_ordering &&
      this.props.branch &&
      this.props.settings.branch_count === 1 &&
      cart.delivered_items > 0 &&
      cart.charged_items > 0
    )
      return false;
    return true;
  };

  componentWillUnmount() {
    this._ismounted = false;
    document.removeEventListener("scroll", this.recommendationIsInViewport);
  }

  recommendationIsInViewport = () => {
    if (!this.recommendationsRef) return;
    try {
      const top = this.recommendationsRef.getBoundingClientRect().top;
      if (top <= window.innerHeight) {
        if (!this.state.recommendationVisibilityRegistered) {
          this.setState({ recommendationVisibilityRegistered: true });
          this.props.registerGlanceView({
            type: "product_recommendations_view",
            source: "cart",
          });
          return;
        }
      }
    } catch (e) {}
  };

  render() {
    const { language, customTexts, cart, cart_items, promo_items, settings } =
      this.props;
    let Item_List = cart_items.map((item, index) => {
      const discountedPrice = getProductDiscountAmount(
        item,
        this.props.coupon,
        this.props.promotions,
        this.props.store.smart_promos
      );

      const priceAfterDiscount = getDiscountedPrice(
        item.total_price * item.quantity + item.quantityExcludedOptionsTotal,
        discountedPrice,
        null,
        item.options,
        item.quantity
      );

      return (
        <CartItem
          discountedPrice={discountedPrice}
          priceAfterDiscount={priceAfterDiscount}
          item={item}
          index={index}
          key={"CartItem" + " " + item.id + " " + index}
          hideDivider={index === cart_items.length - 1 && !promo_items.length}
          calculateNutritions={this.calculateNutritions}
          dietaryRestrictions={this.checkDietryRestriction(item)}
        />
      );
    });
    let Promo_Item_List = promo_items.map((item, index) => {
      return (
        <CartItem
          item={item}
          index={index}
          key={"PromoItem" + " " + item.id + " " + index}
          PromoItem={true}
          priceAfterDiscount={0}
          hideDivider={index === promo_items.length - 1}
          calculateNutritions={this.calculateNutritions}
          dietaryRestrictions={this.checkDietryRestriction(item)}
        />
      );
    });
    const totalCartLength = Item_List.length + Promo_Item_List.length;

    let headerTitle =
      (language === "arabic" && "سلة المشتريات") || "Shopping Cart";
    if (window.location.hostname?.includes("generalassembly.ordable.com")) {
      headerTitle = "Talent Cart";
    }

    return (
      <div
        style={{ minHeight: "100vh", backgroundColor: "#F5F5F5" }}
        className="noselect"
      >
        <ProductHeader
          title={headerTitle}
          onBack={() => {
            this.props.history.length > 2
              ? this.props.history.goBack()
              : this.props.history.replace("/");
          }}
          rightAction={<Button type="primary">share</Button>}
        />
        <div className="free-space-50"></div>
        <ShareCartDrawer
          open={this.state.shareCartDrawerOpen}
          close={() => this.setState({ shareCartDrawerOpen: false })}
        />
        {totalCartLength > 0 ? (
          <div style={{ marginTop: 30 }}>
            {settings.enable_gifts && settings.enable_gifts_staff && (
              <Gift
                SetGift={(gift_value) => this.props.enableIsGift(gift_value)}
                SetGiftMsg={(
                  name,
                  msg,
                  number,
                  link,
                  anonymous,
                  call_recipient,
                  gift_wrapping
                ) => {
                  this.props.setGiftDetails(
                    name,
                    msg,
                    number,
                    link,
                    anonymous,
                    call_recipient,
                    gift_wrapping
                  );
                }}
                name={this.props.promise.gift_name}
                message={this.props.promise.gift_message}
                gift_recipient_number={this.props.promise.gift_recipient_number}
                gift_link={this.props.promise.gift_link}
                send_gift_anonymously={this.props.promise.send_gift_anonymously}
                call_recipient={this.props.promise.call_recipient}
                unknown_location={this.props.promise.unknown_location}
                gift_wrapping={this.props.promise.gift_wrapping}
                errorName={this.state.errorName}
                errorNumber={this.state.errorNumber}
                handleErrorChange={(type, value) => {
                  if (type === "name") {
                    this.setState({ errorName: value });
                  }
                  if (type === "number") {
                    this.setState({ errorNumber: value });
                  }
                }}
                urlPathname={this.props.location.pathname}
              />
            )}

            {((!settings.is_branch_based_ordering &&
              settings.ask_for_car_info) ||
              (settings.is_branch_based_ordering &&
                this.props.branches?.find(
                  (b) => b.id === this.props.branch.branch
                )?.ask_for_car_info)) &&
              (settings.enable_car_qr || settings.enable_table_qr) &&
              !settings.is_menu && <AdditionalInformation fromCart />}

            {settings.enable_coupons_store && <AppliedCoupons />}

            {settings.enable_special_remarks && (
              <SpecialRemarks
                specialRemarks={this.props.promise.special_remarks}
                setSpecialRemarks={(e) =>
                  this.props.setSpecialRemarks(e.target.value)
                }
              />
            )}

            <div style={{ marginTop: 30 }}>
              <p
                className="box-title"
                style={{ textAlign: language === "arabic" ? "right" : "left" }}
              >
                {language == "english" ? "Items" : "المنتجات"}
                {settings.enable_sharing_carts_staff &&
                  settings.enable_sharing_carts &&
                  !!this.props.abandonedCartID && (
                    <span
                      style={{
                        fontWeight: "bold",
                        color: this.props.themeColor,
                        float: language === "arabic" ? "left" : "right",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        this.setState({ shareCartDrawerOpen: true })
                      }
                    >
                      {language === "arabic" ? "مشاركة" : "share"}
                    </span>
                  )}
              </p>
              <div className="bordered">
                <div style={{ padding: "7px 5px", background: "white" }}>
                  {Item_List}
                  {Promo_Item_List}
                </div>
                {/* <div
              className="free-space-80"
              style={{ backgroundColor: "white" }}
            ></div> */}
              </div>
            </div>

            {this.props.settings.enable_tamara_widgets && cart.price > 0 && (
              <div style={{ background: "white", marginTop: 30 }}>
                <tamara-widget
                  type="tamara-summary"
                  amount={cart.price.toFixed(settings.currency_decimals)}
                  lang={this.props.language === "arabic" ? "ar" : "en"}
                  country={this.props.store.default_dial_code.toUpperCase()}
                  inline-type="5"
                  inline-variant="outlined"
                ></tamara-widget>
              </div>
            )}

            {this.props.settings.enable_tabby_widgets && cart.price > 0 && (
              <div style={{ background: "white", marginTop: 30 }}>
                <div id="TabbyPromo"></div>
              </div>
            )}

            {settings.enable_product_recommendations_staff &&
              settings.enable_product_recommendations_cart && (
                <>
                  <span
                    ref={(el) => {
                      this.recommendationsRef = el;
                    }}
                  ></span>
                  <ProductRecommendations cartBased fromCart />
                </>
              )}
            <div style={{ height: 150 }}></div>

            <ActionButton
              action={
                this.shouldShowCheckoutButton()
                  ? language == "english"
                    ? customTexts.go_to_checkout
                    : customTexts.go_to_checkout_ar
                  : language === "arabic"
                  ? customTexts.select_location_ar
                  : customTexts.select_location
              }
              disabled={
                this.props.promise.isGift &&
                (this.state.errorName || this.state.errorNumber)
              }
              errorName={this.state.errorName}
              errorNumber={this.state.errorNumber}
              showNutrition={true}
              nutritionalFacts={this.state.nutritionalFacts}
              onClick={() => {
                if (this.shouldShowCheckoutButton())
                  this.handleDialogContinue();
                else this.props.history.push("/select/branch");
              }}
              total={
                this.shouldShowCheckoutButton()
                  ? cart.price.toFixed(settings.currency_decimals)
                  : undefined
              }
              quantity={
                this.shouldShowCheckoutButton()
                  ? totalCartLength > 0
                    ? totalCartLength
                    : null
                  : undefined
              }
            />
          </div>
        ) : (
          <div className="mt-5 mb-4">
            {settings.enable_coupons_store && <AppliedCoupons />}
            <div style={{ marginTop: 30 }}>
              <p
                className="box-title"
                style={{ textAlign: language === "arabic" ? "right" : "left" }}
              >
                {language == "english" ? "Items" : "المنتجات"}
              </p>
              <div
                className="bordered"
                style={{
                  padding: "30px 20px",
                  display: "grid",
                  gridTemplateColumns: "80px auto",
                  alignItems: "center",
                  direction: language === "arabic" ? "rtl" : "ltr",
                  backgroundColor: "white",
                }}
              >
                <div className="text-center">
                  <Empty
                    style={{
                      width: 60,
                      height: 60,
                    }}
                  />
                </div>
                <div
                  className={
                    language === "arabic" ? "text-right pr-4" : "text-left pl-4"
                  }
                >
                  <p
                    style={{
                      color: "#5b5b5b",
                      marginBottom: 5,
                      fontWeight: "bold",
                    }}
                  >
                    {language === "arabic"
                      ? "سلة مشترياتك فارغة"
                      : "Your cart is empty."}
                  </p>
                  <p style={{ marginBottom: 10 }}>
                    {language === "arabic"
                      ? "اضف بعض المنتجات الى السلة"
                      : "Add some items to your cart."}
                  </p>
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{
                      textTransform: "none",
                      fontWeight: "bold",
                      paddingRight: language === "arabic" && 0,
                    }}
                    onClick={() => this.props.history.replace("/")}
                    startIcon={
                      <NavigateBeforeOutlinedIcon
                        style={{
                          transform: language === "arabic" && "rotate(180deg)",
                          marginLeft: language === "arabic" && 5,
                        }}
                      />
                    }
                  >
                    {language === "arabic" ? "ابدأ التسوق" : "Start Shopping"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    labels: state.store.labels,
    cart_items: state.cart.cart,
    cart: state.cart,
    store: state.store.store,
    promo_items: state.cart.promo_items,
    customTexts: state.store.store.settings.custom_texts,
    settings: state.store.store.settings,
    promise: state.promise,
    branch: state.branch,
    address: state.customers?.address,
    abandonedCartID: state.abandonedCart.id,
    themeColor: state.store.store.settings.dark || "#0099cc",
    branches: state.store.store.branches,
    branch: state.branch,
    promotions: state.cart.discounts,
    coupon: state.cart.promos,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    edit_quantity: (product, quantity) =>
      dispatch(edit_quantity(product, quantity)),
    enableIsGift: (value) =>
      dispatch({ type: "ENABLE_IS_GIFT", payload: value }),
    setGiftDetails: (
      name,
      message,
      number,
      link,
      anonymous,
      call_recipient,
      gift_wrapping
    ) =>
      dispatch({
        type: "SET_GIFT_DETAILS",
        payload: {
          name,
          message,
          number,
          link,
          anonymous,
          call_recipient,
          gift_wrapping,
        },
      }),
    setSpecialRemarks: (sr) =>
      dispatch({ type: "SET_SPECIAL_REMARKS", payload: sr }),
    setSpecialRemarksFiles: (srf, name) =>
      dispatch({
        type: "SET_SPECIAL_REMARKS_FILES",
        payload: { url: srf, name: name },
      }),
    registerGlanceView: (data) => dispatch(registerGlanceView(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
